import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerPerpsMenuIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_11754_6133",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 16,
		height: 16,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				stroke: "#1A1B23",
				strokeWidth: .888889
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5557 0.444336V15.5557H0.444336V0.444336H15.5557Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: .888889
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_11754_6133)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6 3.33331V5.99998",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 3.33331V5.99998",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66669 6H5.33335C4.96516 6 4.66669 6.29848 4.66669 6.66667V9.33333C4.66669 9.70152 4.96516 10 5.33335 10H6.66669C7.03488 10 7.33335 9.70152 7.33335 9.33333V6.66667C7.33335 6.29848 7.03488 6 6.66669 6Z",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66669 6H5.33335C4.96516 6 4.66669 6.29848 4.66669 6.66667V9.33333C4.66669 9.70152 4.96516 10 5.33335 10H6.66669C7.03488 10 7.33335 9.70152 7.33335 9.33333V6.66667C7.33335 6.29848 7.03488 6 6.66669 6Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 10V11.3333",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 10V11.3333",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 2V3.33333",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 2V3.33333",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 3.33331H10.6667C10.2985 3.33331 10 3.63179 10 3.99998V7.99998C10 8.36817 10.2985 8.66665 10.6667 8.66665H12C12.3682 8.66665 12.6667 8.36817 12.6667 7.99998V3.99998C12.6667 3.63179 12.3682 3.33331 12 3.33331Z",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 3.33331H10.6667C10.2985 3.33331 10 3.63179 10 3.99998V7.99998C10 8.36817 10.2985 8.66665 10.6667 8.66665H12C12.3682 8.66665 12.6667 8.36817 12.6667 7.99998V3.99998C12.6667 3.63179 12.3682 3.33331 12 3.33331Z",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 8.66669V10.6667",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3333 8.66669V10.6667",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14",
				stroke: "#1A1B23",
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14",
				stroke: "white",
				strokeOpacity: .5,
				strokeWidth: 1.33333,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgHypertrackerPerpsMenuIcon;
